/**
 * The role a person signs in as. eVault has four personas; the backend
 * refuses the login unless the account holds an active membership in an
 * organization of the chosen type. Investor is a workspace of its own: a
 * platform-wide, read-only view of every package, transaction and audit entry.
 */
export const SIGN_IN_ROLES = [
  { id: 'originator', label: 'Originator' },
  { id: 'provider', label: 'Provider' },
  { id: 'custodian', label: 'Custodian' },
  { id: 'investor', label: 'Investor' },
];

const PENDING_ROLE_KEY = 'evault.pendingSignInRole';

export function isSignInRole(value) {
  return SIGN_IN_ROLES.some((role) => role.id === value);
}

export function roleLabel(roleId) {
  return SIGN_IN_ROLES.find((role) => role.id === roleId)?.label || '';
}

/** Microsoft sign-in leaves the page; keep the chosen role for the callback. */
export function rememberPendingRole(roleId) {
  try {
    if (isSignInRole(roleId)) {
      window.sessionStorage.setItem(PENDING_ROLE_KEY, roleId);
    } else {
      window.sessionStorage.removeItem(PENDING_ROLE_KEY);
    }
  } catch {
    // sessionStorage unavailable (privacy mode) — the backend still gates by role
  }
}

export function takePendingRole() {
  try {
    const value = window.sessionStorage.getItem(PENDING_ROLE_KEY);
    window.sessionStorage.removeItem(PENDING_ROLE_KEY);
    return isSignInRole(value) ? value : null;
  } catch {
    return null;
  }
}
